import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from 'lodash';

export class PlanningRoutesActionButtonComponent implements IController {
  routes: any;
  selectedIds: Function;
  onDispatch: Function;
  onPrint: Function;
  onPrintLoadingSheet: Function;
  onDelete: Function;
  onReoptimize: Function;
  onEditPickingTime: Function;
  onPreAssignAgent: Function;

  public actions: any;

  /* @ngInject */
  constructor(private $timeout: ITimeoutService) {
  }

  $onInit() {
    this.actions = {};
  }

  onOpen($mdMenu, ev) {

    let unRoutedResources: boolean = false;
    let hasLockedRoutes: boolean = false;
    let hasDispatchRoutes: boolean = false;
    let hasUnDispatchRoutes: boolean = false;

    _.forEach(this.selectedIds, (resourceId) => {

      const route = _.find(this.routes, (r) => {
        return r.id === resourceId;
      });

      if (!hasLockedRoutes && _.get(route, 'locked')) {
        hasLockedRoutes = true;
      }

      if (_.get(route, 'status') === 'DISPATCHED') {
        hasDispatchRoutes = true;
      }

      if (!hasUnDispatchRoutes && _.get(route, 'status') !== 'DISPATCHED') {
        hasUnDispatchRoutes = true;
      }
    })

    this.actions = {
      dispatch: !!hasUnDispatchRoutes && !hasDispatchRoutes,
      delete: !hasLockedRoutes,
      canPrint: hasDispatchRoutes && !hasUnDispatchRoutes,
      reoptimize: !hasLockedRoutes,
      preAssignAgent: !hasLockedRoutes && !hasDispatchRoutes
    };

    this.$timeout(0).then(function () {
      $mdMenu.open(ev);
    });
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningRoutesActionButton', {
    bindings: {
      routes: '<',
      selectedIds: '<',
      onDispatch: '&',
      onReoptimize: '&',
      onEditPickingTime: '&',
      onPreAssignAgent: '&',
      onPrint: '&',
      onPrintLoadingSheet: '&',
      onDelete: '&'
    },
    template: require('./planning-routes-action-button.html').default,
    controller: PlanningRoutesActionButtonComponent
  });
